// Centralized constants and strings for the application

import fac1 from '../assets/key1.png';
import smallfac1 from '../assets/smallkeyf1.png';
import smallfac2 from '../assets/smallkeyf2.png';
import smallfac3 from '../assets/smallkeyf3.png';
import fac2 from '../assets/key2.png';
import fac3 from '../assets/key3.png';
import brandClient1 from '../assets/brand client (1).png';
import brandClient2 from '../assets/brand client (2).png';
import brandClient3 from '../assets/brand client (3).png';
import brandClient4 from '../assets/brand client (4).png';
import brandClient5 from '../assets/brand client (5).png';
import brandClient6 from '../assets/brand client (6).png';
import brandClient7 from '../assets/brand client (7).png';
import brandClient8 from '../assets/brand client (8).png';
import brandClient9 from '../assets/brand client (9).png';
import whatWe1 from '../assets/whatwe1.png';
import whatWe2 from '../assets/whatwe2.png';
import whatWe3 from '../assets/whatwe3.png';
import whatWe4 from '../assets/whatwe4.png';
import fac4 from '../assets/FAC4.png';
import fac5 from '../assets/FAC5.png';
import fac6 from '../assets/FAC6.png';
import cuttingImage from '../assets/cuttingImage.png';
import seamingWashingImage from '../assets/seamingWashingImage.png';
import edgingImage from '../assets/edgingImage.png';
import temperingImage from '../assets/temperingImage.png';
import heatSoakingImage from '../assets/heatSoakingImage.png';
import insulatingImage from '../assets/insulatingImage.png';
import laminatingImage from '../assets/laminatingImage.png';
import printingImage from '../assets/printingImage.png';
import infra1 from '../assets/INFRA1.png';
import infra2 from '../assets/INFRA2.png';
import infra3 from '../assets/INFRA3.png';
import infra4 from '../assets/INFRA4.png';
import certi1 from '../assets/c1.png';
import certi2 from '../assets/c2.png';
import certi3 from '../assets/c3.png';
import certi4 from '../assets/c4.png';
import certi5 from '../assets/c5.png';
import WindsorGrand from "../assets/commercial/Windsor Grand.jpg";
import navImg from "../assets/navImage.png";
// import Itpo                 from "../assets/govt/itpo.jpg";
import MedantaImg from "../assets/hospital/MEDANTA.jpg";
// import ScoopHouseImg       from "../assets/residental/Scoop House.jpg";


// // ---------- Commercial image imports ----------
import DlfMallOfIndia            from "../assets/commercial/DLF Mall of India.jpg";
import EmbassyOxygenBusinessPark from "../assets/commercial/Embassy Oxygen Business Park.jpg";
import BhutaniGrandthum          from "../assets/commercial/Bhutani grandthum.jpg";
import TheGrandVeniceMall        from "../assets/commercial/The Grand Venice Mall.jpg";
import SupernovaNoida            from "../assets/commercial/supernova_noida.jpg";
import WindsorTower              from "../assets/commercial/Windsor Grand.jpg";            // see note ↓
import MaconnsGrandStreet        from "../assets/commercial/Maconns Grand street.jpg";
import M3MUrbana                 from "../assets/commercial/M3M Urbana.jpg";
import Hq27Headquarters          from "../assets/commercial/HQ27 The Headquarters.jpg";
import EyeOfNoida                from "../assets/commercial/Eye Of Noida.jpg";
import VinparOfficePark          from "../assets/commercial/Vinpar.jpg";
import SignatureGlobal           from "../assets/commercial/Signature Global.jpg";
import OneQube                   from "../assets/commercial/one qube.jpg";
import AddIndia                  from "../assets/commercial/Add india.jpg";
import Svh83MetroStreet          from "../assets/commercial/SVH 83 Metro Street.jpg";
import RadissonCollection        from "../assets/commercial/Radisson Collection_srinagar.jpg";
import HolidayInnDelhi           from "../assets/commercial/holiday inn_delhi.jpg";
import RadissonBluSonmarg        from "../assets/commercial/Raddisson Blu sonmarg.jpg";
import RamadaNepal               from "../assets/commercial/Ramada by Wyndham Itahari.jpg";

// ---------- Education image imports ----------
import IitJodhpur          from "../assets/education/iit-jodhpurs.jpg";
import IitGandhinagar      from "../assets/education/IIT_GANDHINAGAR.jpg";
import DpsGhaziabad        from "../assets/education/DPS_GHZjpg.jpg";
import AmityInternational  from "../assets/education/AMITY INTERNATIONAL.jpg";
import PathwaysNoida       from "../assets/education/Pathways_noida.jpg";
import GdGoenkaSchool      from "../assets/education/GD Goenka School.jpg";
import LotusValleyNoida    from "../assets/education/Lotus Valley International School_NOIDA.jpg";

// ---------- Government image imports ----------
import Igt3             from "../assets/govt/IGT3.jpg";
import Itpo             from "../assets/govt/itpo.jpg";
import SarsawaAirport   from "../assets/govt/Sarsawa Airport.jpg";
import Nbcc             from "../assets/govt/NBCC.jpg";
import BjpHeadquarters  from "../assets/govt/BJP headquarters.jpg";

// ---------- Healthcare image imports ----------
import MedantaTowerImg  from "../assets/hospital/MEDANTA.jpg";
import FortisHospital   from "../assets/hospital/Fortis Hospital.jpg";

// ---------- Residential image imports ----------
import MahagunMedalleo     from "../assets/residental/Mahagun Medalleo.jpg";
import NorthEyeImg         from "../assets/residental/North Eye.jpg";
import JaypeeGreens        from "../assets/residental/Jaypee Greens.jpg";
import County107           from "../assets/residental/County 107.jpg";
import KalptaruResidency   from "../assets/residental/KalpTaru Residency.jpg";
import ScoopHouseImg       from "../assets/residental/Scoop House.jpg";
import JaypeeAmanImg       from "../assets/residental/Jaypee aman.jpg";
import CantileverHouseImg  from "../assets/residental/The Cantilever House, Ghaziabad.jpg";



// Home page specific strings
export const HOME_PAGE = {
  pageHeaderTitle: "Built on Legacy,\nDriven by Innovation",
  pioneering: {
    heading: `Pioneering Glass \nProcessing With Over 48 \nYears Of Excellence`,
    description:
      `At Sktuff, decades of expertise meet advanced automation to deliver glass solutions that perform. Our cutting-edge facility in Noida produces toughened, laminated, insulating, and decorative glass, engineered for global standards of strength, clarity, and safety. Our glass isn't just material; it promises innovation, precision, and partnership.`,
    aboutButton: "Discover Us",
  },
};

// Features for Home Page
export const FEATURES = [
  {
    title: "Engineered To Outperform",
    description:
      "Our BIS-certified, fully automated Noida facility delivers high-volume glass with unmatched speed, consistency, and scale.",
    image: fac1,
  },
  {
    title: "Innovating With Precision",
    description:
      "Our conveyor-integrated, fully automated facility delivers glass engineered for safety, clarity, and performance across architectural and interior spaces.",
    image: fac2,
  },
  {
    title: "With You, Every Step",
    description:
      "We go beyond production. With custom samples, expert guidance, fast in-house manufacturing, and pan-India delivery, every project is backed by responsive service and lasting support.",
    image: fac3,
  },
];

export const FEATURES_INFRA = [
  {
    title: "Scale Meets Intelligence",
    description:
      "Our Noida plant features NCR's largest furnaces and a U-line layout for nonstop, high-efficiency glass processing.",
    image: fac4, // Replace with actual image path if changed
  },
  {
    title: "Limitless Possibilities",
    description:
      "From compact 350×350 mm panels to towering 5000×2700 mm sheets, we process clear, tinted, patterned, and low-E glass that's as versatile as your imagination.",
    image: fac5,
  },
  {
    title: "Legacy On The Move",
    description:
      "With nearly five decades of experience and a fleet of company-owned vehicles, we guarantee reliable, pan-India delivery.",
    image: fac6,
  },
];

export const SMALLFEATURES = [
  {
    title: "Scale Meets Intelligence",
    description:
      "Our Noida plant features NCR's largest furnaces and a U-line layout for nonstop, high-efficiency glass processing.",
    image: smallfac1, // Replace with actual image path if changed
  },
  {
    title: "Limitless Possibilities",
    description:
      "From compact 350×350 mm panels to towering 5000×2700 mm sheets, we process clear, tinted, patterned, and low-E glass that's as versatile as your imagination.",
    image: smallfac2,
  },
  {
    title: "Legacy On The Move",
    description:
      "With nearly five decades of experience and a fleet of company-owned vehicles, we guarantee reliable, pan-India delivery.",
    image: smallfac3,
  },
];

// Stats for Home Page
export const STATS = [
  {
    value: 3.6,
    suffix: "M+",
    label: "sq mtr of tempered glass produced",
  },
  {
    value: 1.2,
    suffix: "M+",
    label: "sq mtr of insulating glass processed",
  },
  {
    value: 600,
    suffix: "K+",
    label: "sq mtr of laminated safety glass delivered",
  },
  {
    value: 500,
    suffix: "+",
    label: "Projects completed",
  },
];

// Projects for Home Page (short version)
export const PROJECTS = [
  // ---------- Commercial ----------
  { name: "DLF Mall of India",           location: "Noida",           category: "Commercial",  image: DlfMallOfIndia },
  { name: "Embassy Oxygen Business Park",location: "Noida",           category: "Commercial",  image: EmbassyOxygenBusinessPark },
  { name: "Bhutani Grandthum",           location: "Greater Noida",   category: "Commercial",  image: BhutaniGrandthum },
  { name: "The Grand Venice Mall",       location: "Greater Noida",   category: "Commercial",  image: TheGrandVeniceMall },
  { name: "Supernova Tower",             location: "Noida",           category: "Commercial",  image: SupernovaNoida },
  { name: "Windsor Tower",               location: "Noida",           category: "Commercial",  image: WindsorTower },
  { name: "Maconns Grand Street",        location: "Noida",           category: "Commercial",  image: MaconnsGrandStreet },
  { name: "M3M Urbana",                  location: "Gurugram",        category: "Commercial",  image: M3MUrbana },
  { name: "HQ27 The Headquarters",       location: "Gurugram",        category: "Commercial",  image: Hq27Headquarters },
  { name: "Eye Of Noida",                location: "Noida",           category: "Commercial",  image: EyeOfNoida },
  { name: "Vinpar Office Park",          location: "Noida",           category: "Commercial",  image: VinparOfficePark },
  { name: "Signature Global",            location: "Delhi",           category: "Commercial",  image: SignatureGlobal },
  { name: "One Qube",                    location: "Gurugram",        category: "Commercial",  image: OneQube },
  { name: "Add India",                   location: "Noida",           category: "Commercial",  image: AddIndia },
  { name: "SVH 83 Metro Street",         location: "Gurugram",        category: "Commercial",  image: Svh83MetroStreet },
  { name: "Radisson Collection",         location: "Srinagar",        category: "Commercial",  image: RadissonCollection },
  { name: "Holiday Inn",                 location: "Delhi",           category: "Commercial",  image: HolidayInnDelhi },
  { name: "Radisson Blu",                location: "Sonmarg",         category: "Commercial",  image: RadissonBluSonmarg },
  { name: "Ramada",                      location: "Nepal",           category: "Commercial",  image: RamadaNepal },

  // // ---------- Education ----------
  { name: "Indian Institute Of Technology (IIT)", location: "Jodhpur",        category: "Education", image: IitJodhpur },
  { name: "Indian Institute Of Technology (IIT)", location: "Gandhinagar",    category: "Education", image: IitGandhinagar },
  { name: "Delhi Public School",                   location: "Ghaziabad",      category: "Education", image: DpsGhaziabad },
  { name: "Amity International School",            location: "Greater Noida",  category: "Education", image: AmityInternational },
  { name: "Pathways",                              location: "Noida",          category: "Education", image: PathwaysNoida },
  { name: "GD Goenka School",                      location: "Greater Noida",  category: "Education", image: GdGoenkaSchool },
  { name: "Lotus Valley International School",     location: "Noida",          category: "Education", image: LotusValleyNoida },

  // // ---------- Government ----------
  { name: "Indira Gandhi International Airport Terminal 3", location: "Delhi",        category: "Government", image: Igt3 },
  { name: "ITPO",                                             location: "Delhi",        category: "Government", image: Itpo },
  { name: "Sarsawa Airport",                                  location: "Saharanpur",   category: "Government", image: SarsawaAirport },
  { name: "NBCC",                                             location: "Delhi",        category: "Government", image: Nbcc },
  { name: "BJP Headquarters",                                 location: "Delhi",        category: "Government", image: BjpHeadquarters },

  // // ---------- Healthcare ----------
  { name: "Medanta Tower",              location: "Gurugram",       category: "Healthcare", image: MedantaTowerImg },
  { name: "Fortis Hospital",            location: "Greater Noida",  category: "Healthcare", image: FortisHospital },

  // // ---------- Residential ----------
  { name: "Mahagun Medalleo",           location: "Noida",          category: "Residential", image: MahagunMedalleo },
  { name: "North Eye",                  location: "Noida",          category: "Residential", image: NorthEyeImg },
  { name: "Jaypee Greens",              location: "Greater Noida",  category: "Residential", image: JaypeeGreens },
  { name: "County 107",                 location: "Noida",          category: "Residential", image: County107 },
  { name: "KalpTaru Residency",         location: "Greater Noida",  category: "Residential", image: KalptaruResidency },
  { name: "Scoop House",                location: "Delhi",          category: "Residential", image: ScoopHouseImg },
  { name: "Jaypee Aman",                location: "Greater Noida",  category: "Residential", image: JaypeeAmanImg },
  { name: "The Cantilever House",       location: "Ghaziabad",      category: "Residential", image: CantileverHouseImg }
];


export const PROJECTSIMPT = [
  { name: "Bhutani Grandthum", location: "Greater Noida", category: "Commercial", image: BhutaniGrandthum },
    { name: "Indira Gandhi International Airport Terminal 3", location: "Delhi",        category: "Govt", image: Igt3 },
  { name: "DLF Mall of India", location: "Noida", category: "Commercial", image: DlfMallOfIndia },
 { name: "M3M Urbana",                  location: "Gurugram",        category: "Commercial",  image: M3MUrbana },

  // { name: "Bharti Airtel Ltd", location: "Gurugram", category: "Commercial", image: AirtelNoida },
  { name: "Supernova Tower", location: "Noida", category: "Commercial", image: SupernovaNoida },
  { name: "Embassy Oxygen Park", location: "Noida", category: "Commercial", image: EmbassyOxygenBusinessPark },
  { name: "IIT", location: "Gandhinagar", category: "Education", image: IitGandhinagar },
  { name: "ITPO", location: "Delhi", category: "Govt", image: Itpo },
  { name: "Windsor Grand", location: "Noida", category: "Commercial", image: WindsorGrand },
   { name: "North Eye",                  location: "Noida",          category: "Residential", image: NorthEyeImg },
 
 
 
  // { name: "Godrej Majesty", location: "Greater Noida", category: "Commercial", image: GodrejMajesty },
  { name: "Medanta", location: "Gurugram", category: "Healthcare", image: MedantaImg },
    { name: "Jaypee Greens",              location: "Greater Noida",  category: "Residential", image: JaypeeGreens },
  { name: "Holiday Inn", location: "Delhi", category: "Commercial", image: HolidayInnDelhi },
  { name: "Scoop House", location: "Delhi", category: "Residential", image: ScoopHouseImg },  
];
// Partner logos count for Home Page
export const PARTNER_LOGOS_COUNT = 9;
export const PARTNER_LOGOS = [
  brandClient1,
  brandClient2,
  brandClient3,
  brandClient4,
  brandClient5,
  brandClient6,
  brandClient7,
  brandClient8,
  brandClient9,

];
// Product descriptions for Home Page
export const PRODUCTS = [
  {
    title: "Performance & Safety Range",
    description:
      "Glass which is treated to be suitable for use in architectural purposes like façades, lobbies, internal partitions, and other design purposes.",
    // image: to be imported in Home.tsx
  },
  {
    title: "Decorative Range",
    description:
      "Bringing creativity to life through glass by combining color, texture, and print for refined interiors, façades, hospitality, and retail spaces.",
    // image: to be imported in Home.tsx
  },
];

// Footer constants
export const FOOTER = {
  companyDescription:
    "At SKTUFF, we partner with top glass manufacturers and leading brands across sectors, delivering unmatched quality",
  exploreButton: "Enquire",
  sitemap: [
     { label: "Home", href: "" },
    { label: "About", href: "about" },
    { label: "Infrastructure", href: "infrastructure" },
     { label: "Projects", href: "projects" },
    { label: "Products", href: "products" },
   
    
  ],
  contact: {
    address: `5K, Sector 80 Rd, Block A, Phase-2, Noida,\nUttar Pradesh 201305`,
    address1: `5K, Sector 80 Rd, Block A, Phase-2,`,
    address2: ` Noida, Uttar Pradesh 201305`,
    phone: "T: 0120 427 2890",
    email: "E: sktuff@gmail.com",
    heading: "Contact us",
  },
  sitemapHeading: "Sitemap",
};

// Navbar constants
export const NAVBAR = {
  navLinks: [
  { label: "Home", to: "/" },
    { label: "About", to: "/about" },
    { label: "Infrastructure", to: "/infrastructure" },
     { label: "Projects", to: "/projects" },
    { label: "Products", to: "/products" },
   
    
  ],
  products: [
    { label: "Performance & Safety", links: "/performanceAndSaftey",to: "/performanceAndSaftey" },
    { label: "Decorative Range", links: "/decorativeRange",to: "/decorativeRange" },
  ],
  enquireButton: "Enquire",
  megaMenu: {
    image: navImg,
 categories : [
  {
     title: "Performance And Safety",
    link:"/performanceAndSaftey",
    links: [
      { label: "Toughened Glass", to: "/performanceAndSaftey#toughened-glass" },
      { label: "Heat Strengthened Glass", to: "/performanceAndSaftey#heat-strengthened-glass" },
      { label: "Heat Soaked Glass", to: "/performanceAndSaftey#heat-soaked-glass" },
      { label: "Laminated Glass", to: "/performanceAndSaftey#laminated-glass" },
      { label: "Insulated Glass", to: "/performanceAndSaftey#insulated-glass" },
      { label: "Bullet proof", to: "/performanceAndSaftey#bullet-proof" },
    ],
  },
  {
    title: "Decorative Range",
    link:"/decorativeRange",
    links: [
      { label: "UV Digital Print", to: "/decorativeRange#uv-digital-print" },
      { label: "Ceramic/ Lacquered Glass", to: "/decorativeRange#ceramic-lacquered-glass" },
      { label: "Etched/ Acid Washed", to: "/decorativeRange#etched-acid-washed" },
      { label: "Silk Screen", to: "/decorativeRange#silk-screen" },
      { label: "Frosted / Non Reflective", to: "/decorativeRange#frosted-non-reflective" },
      { label: "EVA Lamination", to: "/decorativeRange#eva-lamination" },
    ],
  },
]
  },
};

// About Us page constants
export const ABOUT_US = {
  bannerTitle: "About Us",
  heading: `Pioneering Excellence,\nShaping The Future Of\nGlass Processing`,
  companyDescription: `Mehr Image Pvt. Ltd. is a leading and highly recognized manufacturer of
variety of specialised safety glasses and decorative glasses with a brand
name of SKTuff. Our reputation in the market has developed due to supreme
quality of our products and prompt deliveries and after sale services. Our
products are unique combination of quality and elegance that has led to
rapid growth and progress of our company. Since the inception of our
company, our main concern has been manufacturing quality material that
exceeds the industry standards. We give lot of consideration to the
specific requirements of the customers. All these strategies have made our
company one of the most sought after production house in the market.`,
};

// Enquire page constants
export const ENQUIRE = {
  title: "Enquire",
  comingSoon: "This is the Enquire page. Enquiry form coming soon.",
};

// Infrastructure page constants
export const INFRASTRUCTURE = {
  title: "Infrastructure",
  comingSoon: "This is the Infrastructure page. Details coming soon.",
};

// Products page constants
export const PRODUCTS_PAGE = {
  title: "Products",
  comingSoon: "This is the Products page. Product details coming soon.",
};

// ================= About Page Constants =================
export const ABOUT_PAGE = {
  intro: {
    heading: ` At Sktuff, glass is\njust the beginning`,
    description:
      `We're a team of innovators, engineers, and perfectionists who believe the process is as important as the product. Every sheet we craft reflects our commitment to precision, integrity, and performance. Your vision deserves mastery, not just materials.
With nearly five decades of experience, we operate one of India's most advanced fully automated glass processing facilities in Noida. From toughened and laminated to insulating and decorative glass, our products meet the highest standards using premium inputs from global leaders like Saint-Gobain and Asahi.
What sets us apart is how we partner. We collaborate with architects, consultants, and builders to deliver solutions that are timely, tailored, and transparent, backed by over 500 completed projects across sectors.
`,
  },
  ourClients: {
    heading: 'Our Clients //',
    title: 'Chosen by Leaders,\n Remembered \nfor Results',
    description:
      `From high-rises and hospitals to campuses and civic spaces, our work reflects a deep understanding of design, durability, and precision. We're proud to work alongside India's leading developers, architects, and institutions—not just for what we deliver, but for how we engage. Trust, agility, and consistent performance define every partnership we build.
`,
    logoCount: 13,
     logos: [
      require("../assets/client1.png"),
       require("../assets/client2.png"),
      require("../assets/client3.png"),
       require("../assets/client4.png"),
       require("../assets/client5.png"),
       require("../assets/client6.png"),
        require("../assets/client7.png"),
       require("../assets/client8.png"),
       require("../assets/client9.png"),
       require("../assets/client10.png"),
       require("../assets/client11.png"),
       require("../assets/client12.png"),
        require("../assets/client13.png"),
      
    ],
  },
ourValues: {
  title: 'What We Stand For',
  values: [
    {
      id: 1,
      title: 'Partnerships That Last',
      content:
        'Our relationships with our customers, suppliers, sub-contractors and employees have withstood test of times. These have been nurtured over generations. Sktuff believes in forming relationships based on trust, support and understanding with all its stakeholders.',
     image: whatWe1,
    },
    {
      id: 2,
      title: 'Built On Trust, Delivered With Care',
      content:
        'Each sheet reflects our commitment: delivered on time, crafted with precision, and made to endure. From testing to execution, we never compromise.',
       image: whatWe2,
    },
    {
      id: 3,
      title: 'Sustainable By Intention',
      content:
        'With CNG-powered gensets, rainwater harvesting, and glass waste recycling, our operations are designed to reduce impact and raise responsibility.',
      image: whatWe3,
    },
    {
      id: 4,
      title: 'People First, Always',
      content:
        'We prioritize the safety and well-being of every team member. From safety boots to continuous training and audits, we safeguard those who make safety possible.',
       image: whatWe4,
    },
  ],
},
  timeline: {
    title: 'Our Journey',
    data: [
  {
    year: '1965',
    title: 'Where It All Began',
    description:
      'SK Glass Works was established by Mr. Ajit Singh and his brothers, marking the humble beginnings of a visionary journey in the glass processing industry.',
    image: '4d8059f2-3d4d-4228-92c3-b0bb98d77e78.png',
      },
  {
    year: '1997',
    title: 'A New Generation, A New Direction',
    description:
      'SK Glass Concept was established by the next generation, bringing renewed energy and vision to the business.',
    image: '2133dfe7-5fa9-486d-98c9-2e1e958bbc8f.png',
  },
  {
    year: '2004',
    title: 'Designing The Future',
    description:
      'A decorative glass facility was set up in Noida, blending creativity with precision.',
    image: '354c756c-ef1b-4de1-96d7-aaf51efebfc3.png',
  },
  {
    year: '2007',
    title: 'Built To Withstand',
    description:
      'An in-house tempering line was added to enhance product strength and safety.',
    image: '9ef25016-f30f-49bb-83ba-4aa58aa6dab1.png',
  },
  {
    year: '2009',
    title: 'The Start Of Smarter Insulation',
    description:
      'The first automatic insulating glass line was installed to improve efficiency and performance.',
    image: '5318c67f-5cd1-4786-845b-aee9f431270e.png',
  },
  {
    year: '2012',
    title: 'Lamination, Perfected',
    description:
      'A fully automated lamination line was introduced, setting new standards for safety glass.',
    image: '83ee23dd-5e93-40f9-8254-efb5857264ae.png',
  },
  {
    year: '2017',
    title: 'Automation In Motion',
    description:
      'A conveyor-integrated system streamlined glass handling, improving speed and accuracy.',
    image: 'b4270f76-7e01-48bc-a6e4-0e75eb568d37.png',
  },
  {
    year: '2018',
    title: 'Robotics Take The Lead',
    description:
      'A second insulating line with robotic automation was brought online enhancing production flow.',
    image: '0bdcf251-ca38-4731-92d8-f7ca694c6866.png',
  },
  {
    year: '2022',
    title: 'Print Becomes Art',
    description:
      'UV digital and screen printing expanded the decorative glass offering.',
    image: '0bdcf251-ca38-4731-92d8-f7ca694c6866.png', // reusing same image as placeholder
  },
  {
    year: '2024',
    title: 'Raising The Safety Bar',
    description:
      'A heat soak testing machine was introduced to minimize risk and increase reliability.',
    image: '0bdcf251-ca38-4731-92d8-f7ca694c6866.png', // reusing same image as placeholder
  },
]
  },
};

// ================= Infrastructure Page Constants =================
export const INFRA_PAGE = {
  facility: {
    certificationsLabel: 'Our Certifications //',
    title: 'Our Facility',
    facilities: [
      { label: 'Low-E Glass Washing Machine' },
      { label: 'Italian CNC Cutting Line with Auto Loader' },
      { label: 'IGU Line' },
      { label: 'Aerial View Of The Factory' },
    ],
    logoCount: 5,
    certificationLogos: [certi1, certi2, certi3, certi4, certi5],
  },
  process: {
    title: 'Our Technical Capabilities',
    processes : [
  {
    name: "Cutting",
    machinery: "Italian CNC Cutting Line with Auto Loader",
    description:
      "High-speed, precision cutting of full-size glass sheets for maximum efficiency and minimal wastage.",
    minSize: "300mm x 300mm",
    maxSize: "3000mm x 6000mm",
    image: cuttingImage, // replace with actual image import
  },
  {
    name: "Seaming & Washing",
    machinery: "Online Seaming Machine + Low-E Compatible Glass Washing Machine",
    description:
      "Smooths edges post-cutting while ensuring spotless, coating-safe cleaning.",
    minSize: "400mm x 700mm",
    maxSize: "2500mm x 4000mm",
    image: seamingWashingImage,
  },
  {
    name: "Edging",
    machinery: "Double Edger Line + Vertical CNC",
    description:
      "Achieves polished, dimensionally accurate edges, enhancing safety and aesthetics for all applications.",
    minSize: "350mm x 400mm",
    maxSize: "2400mm x 4200mm",
    image: edgingImage,
  },
  {
    name: "Tempering",
    machinery: "Convection-Type Horizontal Tempering Furnace",
    description:
      "Enhances glass strength and thermal resistance through precise heat treatment.",
    minSize: "250mm x 400mm",
    maxSize: "2700mm x 5000mm",
    image: temperingImage,
  },
  {
    name: "Heat Soaking",
    machinery: "Automated Heat Soak Oven",
    description:
      "Reduces spontaneous breakage by eliminating nickel sulphide inclusions.",
    minSize: "250mm x 450mm",
    maxSize: "2400mm x 4200mm",
    image: heatSoakingImage,
  },
  {
    name: "Insulating",
    machinery: "Vertical Insulating Line with Robotic Sealing",
    description:
      "Manufactures high-performance IGUs with precise gas filling and uniform sealing for superior thermal insulation.",
    minSize: "350mm x 450mm",
    maxSize: "2400mm x 3660mm",
    image: insulatingImage,
  },
  {
    name: "Laminating",
    machinery: "Fully Automatic Lamination Line with Autoclave",
    description:
      "Produces clear, durable laminated glass for safety, acoustic control, and design flexibility.",
    minSize: "250mm x 400mm",
    maxSize: "2400mm x 3660mm",
    image: laminatingImage,
  },
  {
    name: "Printing",
    machinery: "UV Flatbed Digital Printing Machine",
    description:
      "Applies custom artwork, textures, and branding directly onto glass surfaces with vibrant, long-lasting color.",
    minSize: "250mm x 400mm",
    maxSize: "2200mm x 3200mm",
    image: printingImage,
  },
],

  },
  testStandards: {
    title: 'Quality You  Can Trust',
    description:
      'Every glass panel we make goes through rigorous BIS-compliant testing, from impact resistance and optical clarity to thermal stress and durability. Each test ensures our glass meets the highest standards of strength, safety, and performance before it reaches you.',
    tests: [
      { name: 'Zebra Screen Test', standard: 'As per BIS Standard IS 2553', image: infra1 },
      { name: 'Human Impact Test', standard: 'As per BIS Standard IS 2553', image: infra2 },
      { name: 'Ball-Drop Test', standard: 'As per BIS Standard IS 2553', image: infra3 },
      { name: 'Boil & Bake Test', standard: 'As per BIS Standard IS 2553', image: infra4 },
    ],
  },
}; 